<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <span style="font-size: 20px;margin-right: 5px;color: #64696e">[欢迎使用_云算盘]</span> <span style="font-size: 16px;color:#64696e;">v3.1</span>！
                </el-breadcrumb>
            </div>
            <div class="header-div" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:zhangTao:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入查询条件"
                            v-model="markName"
                            clearable>
                    </el-input>
                </div>
            </div>
        </div>
        <el-table :data="tableData" border size="mini" style="width: 100%">
            <el-table-column width="266" label="企业（账套）名称">
                <template slot-scope="scope">
                    <div style="width: 80%;float: left">{{scope.row.qymc}}</div>
                    <div style="width: 20%;float: right">
                        <a style="color: #409EFF;cursor: pointer;margin-right: 15px;" v-if="$hasPerm('business:zhangTao:edit')" @click="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit"></i></a>
                        <a style="color: #409EFF;cursor: pointer;" v-if="$hasPerm('business:zhangTao:remove')" @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></a>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="bwb" label="本位币"></el-table-column>
            <el-table-column prop="qyYear" label="启用年份"></el-table-column>
            <el-table-column prop="qyMonth" label="启用月份"></el-table-column>
            <el-table-column prop="kzzd" width="300" label="会计制度"></el-table-column>
            <el-table-column prop="nsrmc" width="180" label="纳税人名称"></el-table-column>
            <el-table-column prop="nsrcbh" width="180" label="纳税人识别号"></el-table-column>
            <el-table-column label="操作" width="100" v-if="$hasPerm('business:zhangTao:edit,business:zhangTao:remove')">
                <template slot-scope="scope">
                    <a style="color: #409EFF;cursor: pointer;" @click="setCurrZt(scope.row)">选择账套</a>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 5px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[5, 10, 50, 100, 500]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
    </div>
</template>
<script>
    import Edit from './edit'

    export default {
        inject:['reload'],
        name: 'zhangTaoList',
        components: {
            Edit
        },
        data() {
            return {
                currentPage: 1, //初始页
                pageSize: 10, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                markName: '',
                editVisible: false
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/zhangTao/list?td='+new Date()),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'markName': this.markName
                    }
                }).then(r => {
                    this.tableData = r.data.data.rows;
                    this.total = r.data.data.total;
                }).finally(r => {
                })

            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            // 获取当前管理员信息
            setCurrZt(row) {

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/zhangTao/qhZt'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'id': row.id
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        //切换账套时：关闭全部标签页
                        this.$store.commit('common/updateMainTabs', [])

                        localStorage.setItem('CURR_ZT_ID', res.data.data.currZt.id);
                        localStorage.setItem('CURR_ZT_NAME', res.data.data.currZt.qymc);
                        localStorage.setItem('CURR_ZT_DATE', res.data.data.currJz.jzYear+"年"+res.data.data.currJz.jzMonth+"期");

                        this.reload();

                        this.$notify({
                            title: '账套切换成功！',
                            type: 'success',
                            offset: 600
                        });

                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {})

            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int("add");
                })
            },
            handleEdit(index, row) {
                let id = row.id;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id);
                })
            },
            handleDelete(index, row) {
                this.$confirm('确认删除账套?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/zhangTao/remove'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': row.id
                        })
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange(1);
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    }).finally(r => {})
                }).catch(() => {});
            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 50%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }
</style>